<app-header></app-header>
<main class="flex flex-1 flex-col items-center overflow-y-auto overflow-x-hidden">
  <div class="bg-[#274693] w-full relative">
    <div class="absolute -right-20 -top-20 z-0">
      <svg width="502" height="563" viewBox="0 0 502 563" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2852_12228)">
          <path d="M13.2822 403.563L211.017 562.999L502 429.795L306.445 266.203L13.2822 403.563Z" fill="#0F3066"></path>
          <path d="M13.2822 403.564L306.445 266.204L290.506 0L0 139.677L13.2822 403.564Z" fill="#184A9F"></path>
          <path d="M306.445 266.204L502 429.796L484.631 166.386L290.506 0L306.445 266.204Z" fill="#133C80"></path>
        </g>
        <defs>
          <clipPath id="clip0_2852_12228">
            <rect width="502" height="563" fill="white"></rect>
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="flex flex-col md:w-[75%] contain mx-auto pt-10 md:pt-20 pb-4 md:pb-8 justify-start items-start">
      <h1 ngxScrollAnimate [delay]="100" class="text-white z-10"><span class="text-[#0ab2d7]">CITYZ</span> STUDIO</h1>
      <p ngxScrollAnimate [delay]="200" class="text-white z-10 text-sm md:text-base font-medium">NORMALISATION ONLINE DES FICHIERS D'IMPRESSION OOH</p>
      <div class="flex gap-6 md:gap-10 xl:gap-28 mt-8 md:mt-14 z-10 lg:flex-row flex-col w-full">
        <div class="flex-1">
          <h2 ngxScrollAnimate [delay]="300" class="text-white leading-tight">CONTRÔLE &amp;<br>
            CERTIFICATION<br>
            DE FICHIER<br>
            D'IMPRESSION</h2>
        </div>
        <div class="flex flex-1 justify-center items-end" id="simulator">
          <div #gradientElement class="border-gradient w-full h-full relative rounded-[0.8rem]"
               [class]="isDragOver() ? '!border-white/50' : ''">
            <label
              for="kv-upload-0"
              class="cursor-pointer rounded-xl bg-white/15 hover:bg-white/20 transition-colors duration-200 w-full h-full min-h-40 flex items-center justify-center"
              (drop)="onDrop($event)"
              (dragover)="onDragOver($event)"
              (dragenter)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
            >
              <div class="flex flex-col items-center gap-2 pointer-events-none">
                <img src="assets/images/cloud.svg" alt="Cloud" class="w-12 pointer-events-none">
                <span class="text-xs md:text-sm font-semibold tracking-wide text-center mx-6 md:mx-10 text-white">Cliquez ou déposez votre fichier d'impression, PDF, jpg, png...</span>
              </div>
              <input id="kv-upload-0" type="file" class="hidden"
                     (change)="onFileInputChange($event)"
                     accept="application/pdf,image/*"/>
            </label>
          </div>
        </div>
      </div>
      @if (anyRunning() || pages().length > 0) {
        <div class="mt-8 md:mt-14 flex flex-col items-center w-full z-10">
          <div class="w-full h-3 bg-white rounded-full overflow-hidden relative">
            @if (anyRunning()) {
              <div class="absolute h-full w-[20%] bg-[#0ab2d7] rounded-full animate-loading-pill"></div>
            } @else if (allDone()) {
              <div class="absolute h-full w-full bg-green-500 transition-all duration-500"></div>
            }
          </div>
          <p class="mt-3 text-white text-sm font-semibold text-center flex items-center gap-2 tracking-widest uppercase">
            @if (allDone()) {
              <svg class="size-8 text-white shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0303 10.0303C16.3232 9.73744 16.3232 9.26256 16.0303 8.96967C15.7374 8.67678 15.2626 8.67678 14.9697 8.96967L10.5 13.4393L9.03033 11.9697C8.73744 11.6768 8.26256 11.6768 7.96967 11.9697C7.67678 12.2626 7.67678 12.7374 7.96967 13.0303L9.96967 15.0303C10.2626 15.3232 10.7374 15.3232 11.0303 15.0303L16.0303 10.0303Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z" fill="currentColor"></path></svg>
            }
            {{ loadingMessage() }}
          </p>
        </div>
      }
      <div class="z-10 w-full my-6 md:mt-10 flex flex-row gap-2 sm:gap-4 py-1 px-4 items-center justify-center text-white border border-white rounded-xl bg-transparent max-w-lg place-self-center">
        <div class="h-16 w-[4.5rem] sm:h-20 sm:w-24 flex flex-col justify-center items-center rounded-md hover:bg-white/10 cursor-pointer" (click)="setState(0)"
             [ngClass]="{'bg-white/20': state() === 0}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.22 71.21" class="size-12 text-white">
            <g>
              <path fill="currentColor" d="M6.32,2.42c-2.15,0-3.9,1.75-3.9,3.91v58.57c0,2.15,1.75,3.91,3.9,3.91h40.57c2.15,0,3.91-1.75,3.91-3.91V16.95l-11.46.28c-.32,0-.63-.11-.86-.33-.23-.22-.37-.53-.37-.85l-.31-13.64H6.32ZM46.9,71.21H6.32c-3.48,0-6.32-2.84-6.32-6.32V6.32C0,2.84,2.84,0,6.32,0h32.65c.66,0,1.19.52,1.21,1.18l.31,13.61,11.49-.28c.33,0,.64.12.87.34.23.23.36.54.36.86v49.17c0,3.49-2.84,6.32-6.32,6.32"/>
              <path fill="currentColor" d="M52.01,16.92c-.34,0-.67-.14-.91-.41l-11.47-.92c-.44-.5-1.62-14.85-1.11-15.29.5-.44,1.26-.39,1.7.11l12.7,14.5c.44.5.39,1.26-.11,1.7-.23.2-.51.3-.79.3"/>
              <path fill="currentColor" d="M38.19,38.47v-4.18h3.34v4.18h3.54v-10.8h-3.54v3.65h-3.34v-3.65h-3.54v10.8h3.54ZM24.61,27.78c-.69.26-1.29.64-1.78,1.13-.5.49-.88,1.08-1.16,1.76-.27.69-.41,1.45-.41,2.3,0,.92.14,1.74.41,2.45.27.72.65,1.32,1.15,1.81.49.5,1.09.87,1.78,1.12.69.26,1.47.38,2.32.38.8,0,1.55-.13,2.23-.38.69-.25,1.29-.62,1.8-1.11.51-.48.91-1.08,1.2-1.8.29-.71.44-1.53.44-2.45,0-.71-.12-1.4-.35-2.08s-.58-1.27-1.04-1.8c-.47-.53-1.06-.95-1.77-1.27-.72-.32-1.55-.48-2.51-.48-.84,0-1.61.13-2.3.4M27.88,30.26c.27.17.5.4.67.68.17.28.29.61.38.97.08.36.12.72.12,1.09,0,.45-.04.86-.12,1.24-.08.38-.21.7-.38.98-.17.28-.39.5-.66.65-.27.16-.6.23-.98.23-.42,0-.77-.1-1.04-.29-.27-.19-.49-.44-.65-.74-.16-.3-.27-.63-.33-1-.06-.37-.09-.72-.09-1.07s.03-.69.1-1.04c.06-.35.18-.67.34-.96.16-.28.38-.52.65-.7.27-.18.6-.28,1-.28.39,0,.72.07,1,.24M11.66,27.78c-.7.26-1.29.64-1.78,1.13-.5.49-.88,1.08-1.16,1.76-.27.69-.41,1.45-.41,2.3,0,.92.13,1.74.41,2.45.27.72.65,1.32,1.15,1.81.5.5,1.09.87,1.79,1.12.69.26,1.47.38,2.32.38.8,0,1.54-.13,2.24-.38.69-.25,1.29-.62,1.8-1.11.51-.48.91-1.08,1.2-1.8.29-.71.43-1.53.43-2.45,0-.71-.12-1.4-.35-2.08s-.58-1.27-1.04-1.8c-.47-.53-1.06-.95-1.77-1.27-.71-.32-1.55-.48-2.51-.48-.84,0-1.61.13-2.3.4M14.93,30.26c.27.17.5.4.67.68.17.28.3.61.38.97.08.36.12.72.12,1.09,0,.45-.04.86-.12,1.24-.08.38-.2.7-.38.98s-.39.5-.66.65c-.27.16-.6.23-.98.23-.42,0-.77-.1-1.04-.29-.27-.19-.49-.44-.65-.74-.16-.3-.27-.63-.33-1-.06-.37-.09-.72-.09-1.07s.03-.69.1-1.04c.06-.35.18-.67.34-.96.16-.28.38-.52.64-.7.27-.18.61-.28,1.01-.28.39,0,.72.07,1,.24"/>
            </g>
          </svg>
        </div>
        <div class="h-16 w-[4.5rem] sm:h-20 sm:w-24 flex flex-col justify-center items-center rounded-md hover:bg-white/10 cursor-pointer" (click)="setState(1)"
             [ngClass]="{'bg-white/20': state() === 1, 'cursor-default hover:!bg-transparent': !callasFiles()}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.22 71.21" class="size-12 text-white/50"
               [ngClass]="{'!text-white': !!callasFiles()}">
            <g>
              <path fill="currentColor" d="M6.32,2.42c-2.15,0-3.9,1.75-3.9,3.91v58.57c0,2.15,1.75,3.91,3.9,3.91h40.57c2.15,0,3.91-1.75,3.91-3.91V16.95l-11.46.28c-.32.01-.63-.11-.86-.33-.23-.22-.37-.53-.37-.85l-.31-13.64H6.32ZM46.9,71.21H6.32c-3.48,0-6.32-2.84-6.32-6.32V6.32C0,2.84,2.84,0,6.32,0h32.65c.66,0,1.19.52,1.21,1.18l.31,13.61,11.49-.28c.33-.01.64.12.87.34.23.23.36.54.36.86v49.17c0,3.49-2.83,6.32-6.32,6.32"/>
              <path fill="currentColor" d="M52.01,16.92c-.34,0-.67-.14-.91-.41l-12.12-.92c-.44-.5-.97-14.85-.47-15.29.5-.44,1.26-.39,1.7.11l12.7,14.5c.44.5.39,1.26-.11,1.7-.23.2-.51.3-.79.3"/>
              <path fill="currentColor" d="M42.28,41.57h-22.03c-.67,0-1.21-.54-1.21-1.21s.54-1.21,1.21-1.21h22.03c.67,0,1.21.54,1.21,1.21s-.54,1.21-1.21,1.21"/>
              <path fill="currentColor" d="M13.91,40.37c0,1.17-.95,2.12-2.12,2.12s-2.12-.95-2.12-2.12.95-2.12,2.12-2.12,2.12.95,2.12,2.12"/>
              <path fill="currentColor" d="M42.28,54.27h-22.03c-.67,0-1.21-.54-1.21-1.21s.54-1.21,1.21-1.21h22.03c.67,0,1.21.54,1.21,1.21s-.54,1.21-1.21,1.21"/>
              <path fill="currentColor" d="M13.91,53.07c0,1.17-.95,2.12-2.12,2.12s-2.12-.95-2.12-2.12.95-2.12,2.12-2.12,2.12.95,2.12,2.12"/>
              <path fill="currentColor" d="M38.67,30.31h2.12v-2.05l.5-.53,1.56,2.58h2.55l-2.62-4.04,2.37-2.44h-2.49l-1.86,2.1v-2.1h-2.12v6.48ZM37.41,26.3c-.08-.83-.4-1.48-.95-1.95-.55-.46-1.32-.7-2.31-.7-.45,0-.87.08-1.26.24-.39.16-.74.39-1.03.68-.29.29-.52.65-.69,1.07-.17.42-.25.89-.25,1.41s.08,1,.23,1.42c.16.42.38.78.68,1.08.3.3.66.52,1.09.68.43.16.91.24,1.44.24.43,0,.82-.06,1.18-.18.36-.12.67-.3.94-.53.27-.23.49-.51.65-.84.17-.33.28-.7.32-1.12h-2.04c-.04.31-.15.57-.32.78-.17.21-.43.31-.77.31-.27,0-.49-.05-.66-.15-.17-.1-.3-.23-.39-.39-.09-.16-.15-.35-.19-.56-.03-.21-.05-.43-.05-.66,0-.63.1-1.1.31-1.42.21-.31.5-.47.88-.47.34,0,.6.09.81.28.2.18.32.44.35.79h2.02ZM30.05,30.31v-1.51h-3.28v-1.02h2.67v-1.51h-2.67v-.93h3.16v-1.51h-5.28v6.48h5.41ZM18.93,30.31v-2.51h2.01v2.51h2.12v-6.48h-2.12v2.19h-2.01v-2.19h-2.12v6.48h2.12ZM15.6,26.3c-.08-.83-.4-1.48-.95-1.95-.55-.46-1.32-.7-2.31-.7-.45,0-.87.08-1.27.24-.39.16-.73.39-1.03.68-.29.29-.52.65-.69,1.07-.17.42-.25.89-.25,1.41s.08,1,.23,1.42c.16.42.38.78.68,1.08.3.3.66.52,1.09.68.43.16.91.24,1.44.24.43,0,.82-.06,1.18-.18.36-.12.67-.3.94-.53.27-.23.49-.51.65-.84.17-.33.28-.7.32-1.12h-2.04c-.04.31-.15.57-.32.78-.17.21-.43.31-.77.31-.27,0-.49-.05-.66-.15-.17-.1-.3-.23-.39-.39-.09-.16-.15-.35-.18-.56-.03-.21-.05-.43-.05-.66,0-.63.1-1.1.31-1.42.21-.31.5-.47.88-.47.34,0,.6.09.81.28.2.18.32.44.35.79h2.02Z"/>
            </g>
          </svg>
        </div>
        <div class="h-16 w-[4.5rem] sm:h-20 sm:w-24 flex flex-col justify-center items-center rounded-md hover:bg-white/10 cursor-pointer" (click)="setState(2)"
             [ngClass]="{'bg-white/20': state() === 2, 'cursor-default hover:!bg-transparent': !callasFiles()}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.22 71.21" class="size-12 text-white/50"
               [ngClass]="{'!text-white': !!callasFiles()}">
            <g>
              <path fill="currentColor" d="M6.32,2.42c-2.15,0-3.9,1.75-3.9,3.91v58.57c0,2.15,1.75,3.91,3.9,3.91h40.57c2.15,0,3.91-1.75,3.91-3.91V16.95l-11.46.28c-.32,0-.63-.11-.86-.33-.23-.22-.37-.53-.37-.85l-.31-13.64H6.32ZM46.89,71.21H6.32C2.84,71.21,0,68.37,0,64.89V6.32C0,2.84,2.84,0,6.32,0h32.65c.66,0,1.19.52,1.21,1.18l.31,13.61,11.49-.28c.33,0,.64.12.87.34.23.23.36.54.36.86v49.17c0,3.49-2.84,6.32-6.32,6.32"/>
              <path fill="currentColor" d="M52.01,16.92c-.34,0-.67-.14-.91-.41l-11.47-.92c-.44-.5-1.62-14.85-1.11-15.29.5-.44,1.26-.39,1.7.11l12.7,14.5c.44.5.39,1.26-.11,1.7-.23.2-.51.3-.79.3"/>
              <path fill="currentColor" d="M33.4,30.5h3.18v7.97h3.54v-7.97h3.18v-2.83h-9.9v2.83ZM25.82,38.47l.4-1.42h3.52l.42,1.42h3.53l-3.87-10.8h-3.6l-3.87,10.8h3.47ZM29.14,34.79h-2.24l1.1-3.87,1.14,3.87ZM16.42,38.47c.7,0,1.34-.06,1.91-.17.57-.11,1.06-.3,1.47-.56.41-.25.72-.59.94-1s.33-.92.33-1.52-.15-1.11-.46-1.57c-.31-.46-.75-.76-1.34-.91.17-.11.34-.24.51-.4.17-.15.32-.33.46-.52.13-.2.24-.41.32-.65.08-.24.12-.5.12-.78,0-.54-.11-.99-.34-1.33-.22-.35-.53-.63-.93-.83-.4-.2-.86-.35-1.39-.43-.53-.08-1.1-.12-1.71-.12h-5.16v10.8h5.27ZM15.82,33.95c.28,0,.54,0,.78.02.24.02.44.06.61.13s.31.17.4.3c.1.13.15.31.15.56,0,.2-.04.37-.12.49-.08.13-.19.23-.32.31-.13.08-.3.13-.48.15-.19.03-.39.04-.61.04h-1.55v-2h1.12ZM15.94,30.19c.19,0,.37,0,.54.01.17.01.32.04.46.1.14.06.24.14.32.25.08.12.12.28.12.49,0,.32-.11.56-.34.71-.23.16-.52.23-.87.23h-1.47v-1.8h1.24Z"/>
            </g>
          </svg>
        </div>
        <div class="relative">
          <div class="h-16 w-[4.5rem] sm:h-20 sm:w-24 flex flex-col justify-center items-center rounded-md hover:bg-white/20 cursor-pointer" (click)="onDownloadClick()"
               [ngClass]="{'bg-white/15': downloadPopupOpen(), '!cursor-default hover:!bg-transparent': !canDownloadCurrentPage()}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71.16 78.58" class="size-[3.35rem] mt-1 text-white/50 select-none"
                 [ngClass]="{'!text-white': canDownloadCurrentPage()}">
              <g>
                <path fill="currentColor" d="M52.85,14.85c-.23-.23-.55-.36-.87-.34l-11.49.28-.31-13.61c-.01-.65-.55-1.18-1.21-1.18H6.32C2.84,0,0,2.84,0,6.32v58.57c0,3.49,2.84,6.32,6.32,6.32h31.49c-.54-.52-.9-1.23-.97-2.07-.01-.11-.01-.23,0-.34H6.32c-2.15,0-3.91-1.75-3.91-3.9V6.32c0-2.15,1.75-3.91,3.91-3.91h31.47l.31,13.64c0,.32.14.62.37.85.23.22.55.34.86.33l11.46-.28v23.39c.39-.21.97.42,1.42.42.41,0,.64-.68,1-.56V15.71c0-.32-.13-.64-.36-.86"/>
                <path fill="currentColor" d="M52.01,16.92c-.34,0-.67-.14-.91-.41l-11.71-.92c-.44-.5-1.38-14.85-.88-15.29.5-.44,1.27-.39,1.7.11l12.7,14.5c.44.5.39,1.26-.11,1.7-.23.2-.51.3-.79.3"/>
                <path fill="currentColor" d="M51.96,42.6c-9.26,0-16.78,7.53-16.78,16.78s7.53,16.78,16.78,16.78,16.78-7.53,16.78-16.78-7.53-16.78-16.78-16.78M51.96,78.58c-10.59,0-19.2-8.61-19.2-19.2s8.61-19.2,19.2-19.2,19.2,8.61,19.2,19.2-8.61,19.2-19.2,19.2"/>
                <path fill="currentColor" d="M51.96,68.1c-.67,0-1.21-.54-1.21-1.21v-17.8c0-.67.54-1.21,1.21-1.21s1.21.54,1.21,1.21v17.8c0,.67-.54,1.21-1.21,1.21"/>
                <path fill="currentColor" d="M51.96,70.96c-.31,0-.62-.12-.84-.34l-8.47-8.25c-.48-.47-.49-1.23-.02-1.71.47-.48,1.23-.49,1.71-.02l7.59,7.4,6.91-7.36c.46-.49,1.22-.51,1.71-.05.49.46.51,1.22.05,1.71l-7.75,8.25c-.22.24-.53.37-.85.38h-.03"/>
                <text x="27" y="38" fill="currentColor" font-family="Arial, Helvetica, sans-serif" font-weight="bold" font-size="10" text-anchor="middle" letter-spacing="-0.5">PROD</text>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-gradient-to-b from-[#284794] from-50% to-white to-50% w-full" [class.hidden]="state() !== 0">
    <div class="md:w-[75%] contain mx-auto relative">
      <div class="flex items-end justify-between gap-4 mb-4 flex-wrap">
        <h2 class="text-white uppercase">{{ getMockup()?.format }}</h2>
        <ng-container *ngTemplateOutlet="pageDropdown"></ng-container>
      </div>
      <div #solo class="relative w-full h-fit rounded-xl z-20 overflow-hidden bg-white max-h-[86dvh]">
        @if (!hasVisual()) {
          <div class="w-full bg-gray-100 flex flex-col items-center justify-center gap-3 px-8 text-center h-full aspect-1 sm:aspect-[1.5/1]">
            <p class="text-gray-500 font-semibold text-sm uppercase tracking-wide">Pas de visuel disponible pour ce format</p>
            <p class="text-gray-400 text-xs">Le traitement de votre fichier sera tout de même effectué normalement.</p>
          </div>
        } @else {
          @if (isFullscreen()) {
            <button class="text-white absolute top-6 right-20 z-20 drop-shadow-[0_1px_3px_rgba(0,0,0,0.6)]" (click)="document.exitFullscreen()">
              <svg class="size-7" viewBox="0 0 24 24" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_iconCarrier">
                  <path d="M21.7071 3.70711L16.4142 9H20C20.5523 9 21 9.44772 21 10C21 10.5523 20.5523 11 20 11H14.0007L13.997 11C13.743 10.9992 13.4892 10.9023 13.295 10.7092L13.2908 10.705C13.196 10.6096 13.1243 10.4999 13.0759 10.3828C13.0273 10.2657 13.0004 10.1375 13 10.003L13 10V4C13 3.44772 13.4477 3 14 3C14.5523 3 15 3.44772 15 4V7.58579L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711Z"></path>
                  <path d="M9 20C9 20.5523 9.44772 21 10 21C10.5523 21 11 20.5523 11 20V14.0007C11 13.9997 11 13.998 11 13.997C10.9992 13.7231 10.8883 13.4752 10.7092 13.295C10.7078 13.2936 10.7064 13.2922 10.705 13.2908C10.6096 13.196 10.4999 13.1243 10.3828 13.0759C10.2657 13.0273 10.1375 13.0004 10.003 13C10.002 13 10.001 13 10 13H4C3.44772 13 3 13.4477 3 14C3 14.5523 3.44772 15 4 15H7.58579L2.29289 20.2929C1.90237 20.6834 1.90237 21.3166 2.29289 21.7071C2.68342 22.0976 3.31658 22.0976 3.70711 21.7071L9 16.4142V20Z"></path>
                </g>
              </svg>
            </button>
          } @else if (!platform.IOS) {
            <button class="text-white absolute top-6 right-20 z-20 drop-shadow-[0_1px_3px_rgba(0,0,0,0.6)]" (click)="solo.requestFullscreen()">
              <svg xmlns="http://www.w3.org/2000/svg" class="size-7" fill="#ffffff" viewBox="0 0 24 24">
                <path d="M21.7092 2.29502C21.8041 2.3904 21.8757 2.50014 21.9241 2.61722C21.9727 2.73425 21.9996 2.8625 22 2.997L22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V5.41421L14.7071 10.7071C14.3166 11.0976 13.6834 11.0976 13.2929 10.7071C12.9024 10.3166 12.9024 9.68342 13.2929 9.29289L18.5858 4H15C14.4477 4 14 3.55228 14 3C14 2.44772 14.4477 2 15 2H20.9998C21.2749 2 21.5242 2.11106 21.705 2.29078L21.7092 2.29502Z"/>
                <path d="M10.7071 14.7071L5.41421 20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H3.00069L2.997 22C2.74301 21.9992 2.48924 21.9023 2.29502 21.7092L2.29078 21.705C2.19595 21.6096 2.12432 21.4999 2.07588 21.3828C2.02699 21.2649 2 21.1356 2 21V15C2 14.4477 2.44772 14 3 14C3.55228 14 4 14.4477 4 15V18.5858L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071Z"/>
              </svg>
            </button>
          }

          <button class="text-white absolute top-5 right-8 z-20 drop-shadow-[0_1px_3px_rgba(0,0,0,0.6)]" data-html2canvas-ignore="true" (click)="canvas.download()">
            <svg class="size-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
              <g id="SVGRepo_iconCarrier">
                <path d="M21 21H3M18 11L12 17M12 17L6 11M12 17V3" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </g>
            </svg>
          </button>
          <app-canvas #canvas [backImageUrl]="getImageSrc()" [frontMediaFile]="file() ?? visualFile() ?? undefined" [zoom]="currentScale()" [zoomList]="getZooms()"></app-canvas>
        }
      </div>
    </div>
  </div>
  <div class="md:w-[75%] contain mx-auto mt-4 md:mt-8 pb-8 md:pb-16" [class.hidden]="state() !== 0">
    <div class="flex flex-wrap-reverse justify-center gap-4 lg:gap-6">
      @if (hasNight()) {
        <div class="flex grow justify-center flex-nowrap text-sm lg:text-base">
          <button type="button"
                  class="relative overflow-hidden group hover:text-white whitespace-nowrap min-w-fit w-24 md:w-36 px-4 py-3 lg:px-6 lg:py-4 uppercase font-semibold border border-[#0ab2d7] border-solid first:rounded-l-lg last:rounded-r-lg first:ml-0 -ml-px"
                  [class]="!isNight() ? 'text-white' : 'text-[#0ab2d7]'"
                  (click)="selectDayNight('day')"
                  [attr.aria-pressed]="!isNight()">
            Jour
            <div class="scale-150 rounded-full bg-[#0ab2d7] absolute left-0 top-0 h-full w-full z-[-1] group-aria-pressed:translate-x-0 group-hover:translate-x-0 translate-x-[-130%] pointer-events-none transition-all duration-300"></div>
          </button>
          <button type="button"
                  class="relative overflow-hidden group hover:text-white whitespace-nowrap min-w-fit w-24 md:w-36 px-4 py-3 lg:px-6 lg:py-4 uppercase font-semibold border border-[#0ab2d7] border-solid first:rounded-l-lg last:rounded-r-lg first:ml-0 -ml-px"
                  [class]="isNight() ? 'text-white' : 'text-[#0ab2d7]'"
                  (click)="selectDayNight('night')"
                  [attr.aria-pressed]="isNight()">
            Nuit
            <div class="scale-150 rounded-full bg-[#0ab2d7] absolute left-0 top-0 h-full w-full z-[-1] group-aria-pressed:translate-x-0 group-hover:translate-x-0 translate-x-[-130%] pointer-events-none transition-all duration-300"></div>
          </button>
        </div>
      }
      @if (getZooms().length > 1) {
      <div class="flex grow justify-center flex-nowrap text-sm lg:text-base overflow-x-auto no-scrollbar">
        @for (z of getZooms(); track $index) {
          <button type="button"
                  class="relative overflow-hidden group hover:text-white whitespace-nowrap min-w-fit w-24 md:w-36 px-4 py-3 lg:px-6 lg:py-4 uppercase font-semibold border border-[#0ab2d7] border-solid first:rounded-l-lg last:rounded-r-lg first:ml-0 -ml-px"
                  [class]="selectedZoomIdx() === $index ? 'text-white' : 'text-[#0ab2d7]'"
                  (click)="selectZoom($index)"
                  [attr.aria-pressed]="selectedZoomIdx() === $index">
            <span class="sm:hidden">{{ z.name + ' M' }}</span><span class="hidden sm:inline">{{ z.name + ' Mètres' }}</span>
            <div class="scale-150 rounded-full bg-[#0ab2d7] absolute left-0 top-0 h-full w-full z-[-1] group-aria-pressed:translate-x-0 group-hover:translate-x-0 translate-x-[-130%] pointer-events-none transition-all duration-300"></div>
          </button>
        }
      </div>
      }
    </div>
  </div>
  <div class="bg-gradient-to-b from-[#284794] from-50% to-white to-50% w-full" [class.hidden]="state() !== 1">
  <div class="md:w-[75%] contain mx-auto w-full pb-8 md:pb-16 h-fit">
    <div class="flex items-end justify-between gap-4 mb-4 flex-wrap">
      <h2 class="text-white uppercase">{{ getMockup()?.format }}</h2>
      <ng-container *ngTemplateOutlet="pageDropdown"></ng-container>
    </div>
    <div class="relative w-full h-fit md:h-[86dvh] rounded-xl z-20 overflow-hidden bg-white md:max-h-[86dvh]">
      <div class="relative w-full bg-white rounded-xl overflow-hidden flex flex-col h-full">
        <div class="w-full bg-[#0ab2d7] py-6 shrink-0 flex flex-col items-center justify-center transition-colors duration-500">
          @if (!callasFiles()) {
          } @else if (callasFiles()?.errors?.length) {
            <svg class="size-24 text-red-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"></circle>
              <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            </svg>
          } @else {
            <svg class="size-24 text-green-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.0303 10.0303C16.3232 9.73744 16.3232 9.26256 16.0303 8.96967C15.7374 8.67678 15.2626 8.67678 14.9697 8.96967L10.5 13.4393L9.03033 11.9697C8.73744 11.6768 8.26256 11.6768 7.96967 11.9697C7.67678 12.2626 7.67678 12.7374 7.96967 13.0303L9.96967 15.0303C10.2626 15.3232 10.7374 15.3232 11.0303 15.0303L16.0303 10.0303Z" fill="currentColor"></path>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z" fill="currentColor"></path>
            </svg>
          }
          <h3 class="text-white text-xl text-center font-bold m-2">
            {{ !callasFiles() ? 'Votre fichier est en cours de traitement' : callasFiles()?.errors?.length ? 'Votre fichier contient des erreurs' : 'Votre fichier est conforme' }}
          </h3>
        </div>
        <div class="flex-1 p-4 md:p-6 bg-gray-50 md:min-h-0 md:overflow-hidden">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 h-auto md:h-full md:min-h-0">
            <div class="flex flex-col bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden h-fit md:h-full md:min-h-0">
              <div class="p-3 border-b border-gray-100 bg-gray-50 shrink-0">
                <h3 class="font-bold text-gray-700 flex items-center gap-2"><span class="text-blue-500">?</span> Vérifications</h3>
              </div>
              <div class="p-4 md:flex-1 md:overflow-y-auto md:min-h-0">
                <ul class="space-y-3 text-sm text-gray-600">
                  @for (info of callasFiles()?.checks ?? []; track $index) {
                    <li class="flex items-start gap-2">
                      <span class="mt-1.5 w-1.5 h-1.5 rounded-full bg-blue-500 flex-shrink-0"></span>
                      <span class="leading-relaxed">{{ info }}</span>
                    </li>
                  } @empty {
                    <li class="italic text-gray-400 text-center mt-4">Aucune vérification nécessaire.</li>
                  }
                </ul>
              </div>
            </div>
            <div class="flex flex-col bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden h-fit md:h-full md:min-h-0">
              <div class="p-3 border-b border-gray-100 bg-gray-50 shrink-0">
                <h3 class="font-bold text-gray-700 flex items-center gap-2"><span class="text-green-500">✓</span> Corrections</h3>
              </div>
              <div class="p-4 md:flex-1 md:overflow-y-auto md:min-h-0">
                <ul class="space-y-3 text-sm text-gray-600">
                  @for (info of callasFiles()?.corrections ?? []; track $index) {
                    <li class="flex items-start gap-2">
                      <span class="mt-1.5 w-1.5 h-1.5 rounded-full bg-green-500 flex-shrink-0"></span>
                      <span class="leading-relaxed">{{ info }}</span>
                    </li>
                  } @empty {
                    <li class="italic text-gray-400 text-center mt-4">Aucune correction nécessaire.</li>
                  }
                </ul>
              </div>
            </div>
            <div class="flex flex-col bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden h-fit md:h-full md:min-h-0">
              <div class="p-3 border-b border-gray-100 bg-gray-50 shrink-0">
                <h3 class="font-bold text-gray-700 flex items-center gap-2"><span class="text-red-500">⚠</span> Erreurs</h3>
              </div>
              <div class="p-4 md:flex-1 md:overflow-y-auto md:min-h-0">
                <ul class="space-y-3 text-sm text-red-600">
                  @for (error of callasFiles()?.errors ?? []; track $index) {
                    <li class="flex items-start gap-3 bg-red-50 p-2.5 rounded border border-red-100">
                      <span class="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-500 flex-shrink-0"></span>
                      <span class="font-medium leading-relaxed">{{ convertService.CalErrorTexts[error] ?? error }}</span>
                    </li>
                  } @empty {
                    <li class="italic text-gray-400 text-center mt-4">Aucune erreur détectée.</li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  @if (previewPdf(); as url) {
    <div class="bg-gradient-to-b from-[#284794] from-50% to-white to-50% w-full" [class.hidden]="state() !== 2">
    <div class="md:w-[75%] contain mx-auto w-full pb-8 md:pb-16 h-fit">
      <div class="flex items-end justify-between gap-4 mb-4 flex-wrap">
        <h2 class="text-white uppercase">{{ getMockup()?.format }}</h2>
        <ng-container *ngTemplateOutlet="pageDropdown"></ng-container>
      </div>
      <div class="relative w-full h-[70dvh] rounded-xl z-20 overflow-hidden bg-white">
        <div class="w-full h-full flex flex-col shadow-sm">
          <app-pdf-viewer [pdfUrl]="url" class="flex-1"></app-pdf-viewer>
        </div>
      </div>
    </div>
    </div>
  }
  @if (pickerVisible()) {
    <div class="stop-scroll fixed z-50 w-full h-full top-0 left-0">
      <div class="flex justify-center items-center w-full h-full bg-black/60" (click)="closePicker()">
        <div class="relative bg-white rounded-xl w-[600px] h-fit max-w-[90vw] max-h-[80vh] mx-6 flex flex-col items-center justify-center p-4 md:p-8"
             (click)="$event.stopPropagation()">
          <button type="button" class="absolute text-lg top-2 right-3 text-neutral-900/70 hover:text-neutral-900" (click)="closePicker()">✕</button>
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-xl text-neutral-900 font-semibold">Choisissez votre environnement</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 w-full gap-4 overflow-y-auto overscroll-contain">
            @for (mi of pickerMatches(); track mi) {
              @if(mockups()[mi]; as mockup) {
                @if (mockup.showDay) {
                  <div class="flex flex-col items-center justify-start" (click)="selectMockupFromPicker(mi)">
                    <div class="w-full h-fit bg-white rounded-lg transition-all group overflow-hidden cursor-pointer">
                      @if (mockup.preview) {
                        <img [src]="'assets/preview_mockups/' + mockup.preview" alt="Mockup"
                             class="aspect-[1.5/1] object-cover rounded-lg transition-transform duration-500"
                             [style.transform]="'scale(' + getPenultimateZoom(mockup) + ')'"
                             [style.--hover-scale]="getPenultimateZoom(mockup) * 1.05"/>
                      } @else {
                        <div class="aspect-[1.5/1] rounded-lg bg-gray-100 flex items-center justify-center">
                          <span class="text-gray-400 text-xs font-semibold uppercase tracking-wide text-center px-2">{{ mockup.format }}</span>
                        </div>
                      }
                    </div>
                    <h3 class="text-center mt-2 text-[#0ab2d7] font-bold">{{ mockup.format }}</h3>
                  </div>
                }
                @if (mockup.showNight) {
                  <div class="flex flex-col items-center justify-start" (click)="selectMockupFromPicker(mi); selectDayNight('night')">
                    <div class="w-full h-fit bg-white rounded-lg transition-all group overflow-hidden cursor-pointer">
                      @if (mockup.preview2) {
                        <img [src]="'assets/preview_mockups/' + mockup.preview2" alt="Mockup"
                             class="aspect-[1.5/1] object-cover rounded-lg transition-transform duration-500"
                             [style.transform]="'scale(' + getPenultimateZoom(mockup) + ')'"
                             [style.--hover-scale]="getPenultimateZoom(mockup) * 1.05"/>
                      } @else {
                        <div class="aspect-[1.5/1] rounded-lg bg-gray-100 flex items-center justify-center">
                          <span class="text-gray-400 text-xs font-semibold uppercase tracking-wide text-center px-2">{{ mockup.format }}</span>
                        </div>
                      }
                    </div>
                    <h3 class="text-center mt-2 text-[#0ab2d7] font-bold">{{ mockup.format }}</h3>
                  </div>
                }
              }
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (errorMsg() !== 0) {
    <div class="stop-scroll fixed z-50 w-full h-full top-0 left-0">
      <div class="flex justify-center items-center w-full h-full bg-black/60" (click)="resetErrorMsg()">
        <div class="relative bg-white rounded-xl w-fit h-fit max-w-96 max-h-[85vh] mx-6 flex flex-col items-center justify-center p-4 md:p-8"
             (click)="$event.stopPropagation()">
          <button type="button" class="absolute text-lg top-2 right-3 text-neutral-900 hover:text-neutral-900/70 duration-200" (click)="resetErrorMsg()">✕</button>
          <div class="overflow-y-auto w-full text-center">
            @switch (errorMsg()) {
              @case (1) {
                <p class="text-neutral-900 mb-4">Format de fichier non supporté.</p>
                <p class="text-neutral-900">Veuillez téléverser un fichier PDF ou une image.</p>
              }
              @case (2) {
                <p class="text-neutral-900 mb-4 text-sm">Le ratio de votre fichier ne correspond à aucun format d'affichage disponible.</p>
                <p class="text-neutral-900 mb-4 text-sm">Veuillez adapter votre fichier selon ces dimensions&nbsp;:</p>
                <table class="w-full border-collapse text-sm">
                  <thead>
                  <tr class="border-b border-neutral-200">
                    <th class="text-center py-2 px-4 font-semibold text-neutral-900 whitespace-nowrap">Format</th>
                    <th class="border-l border-neutral-200 text-center py-2 px-4 font-semibold text-neutral-900 whitespace-nowrap">Dimensions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">2M²</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">118,5 × 175 cm</td>
                  </tr>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">8m²</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">313 × 230 cm</td>
                  </tr>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">AV 139*31,5</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">139 × 31,5 cm</td>
                  </tr>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">AV 100*25</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">100 × 25 cm</td>
                  </tr>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">AV 104*27</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">104 × 27 cm</td>
                  </tr>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">AR 99*83</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">99 × 83 cm</td>
                  </tr>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">AR 100*147,5</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">100 × 147,5 cm</td>
                  </tr>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">FG 274*68</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">274 × 68 cm</td>
                  </tr>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">FD 152*68</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">152 × 68 cm</td>
                  </tr>
                  <tr class="border-b border-neutral-200">
                    <td class="py-2 px-3 text-center text-neutral-900">FD 177*68</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">177 × 68 cm</td>
                  </tr>
                  <tr>
                    <td class="py-2 px-3 text-center text-neutral-900">FD 192*68</td>
                    <td class="border-l border-neutral-200 py-2 px-3 text-center text-neutral-900">192 × 68 cm</td>
                  </tr>
                  </tbody>
                </table>
              }
              @case (3) {
                <p class="text-neutral-900 mb-4">Votre document contient trop de pages.</p>
                <p class="text-neutral-900">Le nombre maximum de pages accepté est de 15.</p>
              }
            }
          </div>
        </div>
      </div>
    </div>
  }
</main>

@if (downloadPopupOpen()) {
  <div class="stop-scroll fixed z-50 w-full h-full top-0 left-0">
    <div class="flex justify-center items-center w-full h-full bg-black/60" (click)="downloadPopupOpen.set(false)">
      <div class="relative bg-white rounded-xl w-full max-w-md mx-6 flex flex-col p-6 md:p-8 gap-6" (click)="$event.stopPropagation()">
        <button type="button" class="absolute text-lg top-2 right-3 text-neutral-900/70 hover:text-neutral-900 duration-200" (click)="downloadPopupOpen.set(false)">✕</button>
        <h3 class="text-neutral-900 font-bold text-xl">Télécharger</h3>
        <div class="flex flex-col gap-2">
          <label class="text-neutral-500 text-xs font-semibold uppercase tracking-widest">Numéro de commande <span class="text-red-400">*</span></label>
          <input
            type="text"
            class="border rounded-lg px-4 py-3 text-neutral-900 placeholder-neutral-300 text-sm focus:outline-none transition-colors w-full"
            [class.border-neutral-200]="orderNumber.untouched || orderNumber.valid"
            [class.border-red-300]="orderNumber.touched && orderNumber.invalid"
            placeholder="ex: CMD-2024-001"
            [formControl]="orderNumber"
          />
          @if (orderNumber.touched && orderNumber.invalid) {
            <p class="text-red-400 text-xs">Veuillez saisir un numéro de commande.</p>
          }
        </div>
        @if (allDownloadable()) {
          <div class="flex flex-col gap-3">
            <button type="button"
              class="w-full py-3 rounded-xl transition-colors text-white font-bold text-sm uppercase tracking-widest"
              [class.bg-[#0ab2d7]]="orderNumber.valid"
              [class.hover:bg-[#09a0c2]]="orderNumber.valid"
              [class.bg-neutral-200]="orderNumber.invalid"
              [class.cursor-not-allowed]="orderNumber.invalid"
              [disabled]="orderNumber.invalid"
              (click)="downloadScope.set('current'); downloadWithOrder()">
              Télécharger la page actuelle
            </button>
            <button type="button"
              class="w-full py-3 rounded-xl border-2 transition-colors font-bold text-sm uppercase tracking-widest"
              [class.border-[#0ab2d7]]="orderNumber.valid"
              [class.text-[#0ab2d7]]="orderNumber.valid"
              [class.hover:bg-[#0ab2d7]/10]="orderNumber.valid"
              [class.border-neutral-200]="orderNumber.invalid"
              [class.text-neutral-300]="orderNumber.invalid"
              [class.cursor-not-allowed]="orderNumber.invalid"
              [disabled]="orderNumber.invalid"
              (click)="downloadScope.set('all'); downloadWithOrder()">
              Télécharger toutes les pages
            </button>
          </div>
        } @else {
          <button type="button"
            class="w-full py-3 rounded-xl transition-colors text-white font-bold text-sm uppercase tracking-widest"
            [class.bg-[#0ab2d7]]="orderNumber.valid"
            [class.hover:bg-[#09a0c2]]="orderNumber.valid"
            [class.bg-neutral-200]="orderNumber.invalid"
            [class.cursor-not-allowed]="orderNumber.invalid"
            [disabled]="orderNumber.invalid"
            (click)="downloadScope.set('current'); downloadWithOrder()">
            Télécharger
          </button>
        }
      </div>
    </div>
  </div>
}

<app-footer></app-footer>

<!-- Shared page dropdown template -->
<ng-template #pageDropdown>
  @if (pages().length > 1) {
    <div class="flex items-center gap-3 self-end pb-1 min-w-0">
      @if (errorSummaryText()) {
        <span class="text-red-300 text-sm font-medium min-w-0">{{ errorSummaryText() }}</span>
      }
      <div class="relative shrink-0">
        <button
          type="button"
          class="flex items-center gap-2 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white border border-white/30 rounded-lg px-3 py-1.5 text-sm transition-colors"
          (click)="pageDropdownOpenRight.set($event.clientX < window.innerWidth / 2); pageDropdownOpen.set(!pageDropdownOpen())"
        >
          <span>Page {{ selectedPageIdx() + 1 }}</span>
          <svg class="size-3.5 text-white/70 transition-transform duration-200" [class.rotate-180]="pageDropdownOpen()" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
          </svg>
        </button>
        @if (pageDropdownOpen()) {
          <div class="fixed inset-0 z-40" (click)="pageDropdownOpen.set(false)"></div>
          <div class="absolute top-full mt-2 z-50 min-w-48 rounded-xl border border-white/10 bg-gray-900/55 backdrop-blur-2xl shadow-[0_12px_40px_rgba(0,0,0,0.55)] py-1 overflow-y-auto max-h-52"
               [class]="pageDropdownOpenRight() ? 'left-0' : 'right-0'">
            @for (page of pages(); track $index) {
              <button
                type="button"
                class="w-full flex items-center gap-2 px-3 py-2 text-sm text-left transition-colors text-white"
                [class]="page.skipped || page.file === null ? 'opacity-40 cursor-default' : 'hover:bg-white/10'"
                (click)="selectPage($index)"
              >
                <span class="size-2 rounded-full shrink-0" [class]="pageStatusClass(page)"></span>
                <span class="flex-1 font-medium">
                  Page {{ $index + 1 }}
                </span>
                @if (page.skipped) {
                  <span class="font-normal text-xs text-red-300">Format invalide</span>
                }
                @if ((page.callasFiles?.errors?.length ?? 0) > 0) {
                  <span class="text-xs text-red-300 font-semibold shrink-0">{{ page.callasFiles!.errors!.length }} erreur{{ page.callasFiles!.errors!.length > 1 ? 's' : '' }}</span>
                }
                @if (page.callasRunning) {
                  <span class="text-xs text-white/50 shrink-0">...</span>
                }
              </button>
            }
          </div>
        }
      </div>
    </div>
  }
</ng-template>
